export const PICKFACE_STORAGE_TYPE = 'pickface'
export const TARGETED_TYPE_TARGETTED_USER_ID = 'targeted user'
export const LOCATION_VENDING_MACHINE_ID = 'vending machine'
